
export default [
{
    path: '/admin_panel',
    name: 'AdminPanel',
    meta: { RequiresAuth: true },
    component: () => import('@/layouts/DefaultLayout.vue'),
    children: [
      {
        path: '',
        name: 'AdminPanelHome', // Ensure a unique name
        component: () => import('@/views/AdminPages/AdminPanel.vue'),
      },
      {
        path: 'Classic_Tools',
        name: 'Classic Tools',
        component: () => import('@/views/ToolsPages/Classic_Tools.vue'),
      },
      {
        path: 'manual_user_merge',
        name: 'Manual User Merge',
        component: () => import('@/views/ToolsPages/Manual_User_Merge.vue'),
      },
      {
        path: 'demo',
        name: 'Demo Page',
        component: () => import('@/views/AdminPages/Demo.vue'),
      },
      {
        path: 'upload_results_file',
        name: 'Upload Results File',
        component: () => import('@/views/ToolsPages/Upload_Results_File.vue'),
      },
      {
        path: 'pre_event_override',
        name: 'Pre Event Override',
        component: () => import('@/views/ToolsPages/Pre_Event_Override.vue'),
      },
      {
        path: 'import_results',
        name: 'Import_Results',
        component: () => import('@/views/ToolsPages/Import_Results.vue'),
      },
      {
        path: 'variable_print',
        name: 'Variable Print',
        component: () => import('@/views/ToolsPages/Variable_Print.vue'),
      },
      {
        path: 'banner_config_tool',
        name: 'Banner Config Tool',
        component: () => import('@/views/ToolsPages/Banner_Config_Tool.vue'),
      },
            {
        path: 'popup_config_tool',
        name: 'Popup Config Tool',
        component: () => import('@/views/ToolsPages/Popup_Config_Tool.vue'),
      },
      {
        path: 'quiz_config_tool',
        name: 'Quiz Config Tool',
        component: () => import('@/views/ToolsPages/Quiz_Config_Tool.vue'),
      },
      {
        path: 'tos_effective_date',
        name: 'ToS Effective Date',
        component: () => import('@/views/ToolsPages/Tos_Effective_Date.vue'),
      },
      {
        path: 'add_new_club',
        name: 'Add New Club',
        component: () => import('@/views/ConfigurationPages/Add_New_Club.vue'),
      },
      {
        path: 'add_new_county',
        name: 'Add New County',
        component: () => import('@/views/ConfigurationPages/Add_New_County.vue'),
      },
      {
        path: 'add_new_admin',
        name: 'Add New Admin',
        component: () => import('@/views/ConfigurationPages/Add_New_Admin.vue'),
      },
      {
        path: 'add_new_feature_detail',
        name: 'Add New Feature Detail',
        component: () => import('@/views/ConfigurationPages/Add_New_Feature_Detail.vue'),
      },
      {
        path: 'add_new_feature',
        name: 'Add New Feature',
        component: () => import('@/views/ConfigurationPages/Add_New_Feature.vue'),
      },
      {
        path: 'add_new_federation',
        name: 'Add New Federation',
        component: () => import('@/views/ConfigurationPages/Add_New_Federation.vue'),
      },
      {
        path: 'add_new_membership',
        name: 'Add New Membership',
        component: () => import('@/views/ConfigurationPages/Add_New_Membership.vue'),
      },
      {
        path: 'edit_club',
        name: 'Edit Club',
        component: () => import('@/views/ConfigurationPages/Edit_Club.vue'),
      },
      {
        path: 'edit_county',
        name: 'Edit County',
        component: () => import('@/views/ConfigurationPages/Edit_County.vue'),
      },
      {
        path: 'add_new_player',
        name: 'Add New Player',
        component: () => import('@/views/ToolsPages/Add_New_Player.vue'),
      },
      {
        path: 'upload_stripe_prices',
        name: 'Upload Stripe Prices',
        component: () => import('@/views/ToolsPages/Upload_Stripe_Prices.vue'),
      }
    ],
  }]